import { SVGProps } from '@components/Icon/types';

export const FollowLink = ({
  fill = '#000',
  size = 24,
  ...props
}: SVGProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={`${size}px`}
    height={`${size}px`}
    viewBox="0 0 24 24"
    fill="none"
    {...props}>
    <path
      d="M11 4.29865C11.3863 4.29878 11.7 4.61252 11.7002 4.99884C11.7002 5.38536 11.3865 5.6989 11 5.69904H8.59961C6.66919 5.69909 5.49941 6.08953 4.79492 6.79376C4.09053 7.49816 3.70031 8.66798 3.7002 10.5984V15.3992C3.70025 17.3299 4.09053 18.4995 4.79492 19.2039C5.49937 19.9084 6.66888 20.2986 8.59961 20.2986H13.4004C15.331 20.2986 16.5007 19.9083 17.2051 19.2039C17.9093 18.4994 18.2998 17.3297 18.2998 15.3992V12.9988C18.3 12.6124 18.6135 12.2986 19 12.2986C19.3863 12.2988 19.7 12.6125 19.7002 12.9988V15.3992C19.7001 17.4679 19.2905 19.0987 18.1953 20.1942C17.0999 21.2895 15.4691 21.699 13.4004 21.699H8.59961C6.53075 21.699 4.90012 21.2896 3.80469 20.1942C2.70932 19.0987 2.29986 17.468 2.2998 15.3992V10.5984C2.29991 8.5298 2.70933 6.89889 3.80469 5.80353C4.90012 4.70834 6.53097 4.2987 8.59961 4.29865H11ZM21.4453 2.26447C21.6167 2.27367 21.772 2.33874 21.8984 2.43829C21.9239 2.45712 21.9488 2.47699 21.9717 2.49982C21.9948 2.52294 22.0152 2.54825 22.0342 2.57404C22.1331 2.70025 22.1969 2.85532 22.2061 3.02618L22.6035 10.4901C22.6272 10.934 22.2867 11.3139 21.8428 11.3377C21.3987 11.3614 21.0188 11.0201 20.9951 10.576L20.6934 4.91583L10.7861 14.824C10.39 15.2199 9.81439 15.2859 9.5 14.9715C9.18572 14.6571 9.25159 14.0815 9.64746 13.6854L19.5547 3.77716L13.8955 3.47638C13.4516 3.45267 13.1113 3.07363 13.1348 2.6297C13.1584 2.1856 13.5373 1.84437 13.9814 1.86798L21.4453 2.26447Z"
      fill={fill}
    />
  </svg>
);

export const ICON_NAME = 'follow-link';
